// MinimalLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';

const MinimalLayout: React.FC = () => {
    return (
        <>
                <Outlet />
        </>
    );
};

export default MinimalLayout;